<template>
  <a-drawer
    :visible="isVisible"
    :title="$tm('statistic.filter.selectDepartment')"
    placement="right"
    :closable="false"
    :width="400"
    :body-style="{
      padding: 0
    }"
    :mask-style="{
      backgroundColor: 'transparent'
    }"
    @update:visible="res => $emit('update:is-visible', res)"
  >
    <div class="tree-container">
      <a-tree
        v-model:expandedKeys="expandedKeys"
        v-model:selectedKeys="selectedKeys"
        v-model:checkedKeys="checkedKeys"
        :load-data="onLoadData"
        :tree-data="treeData"
        checkable
        check-strictly
        show-icon
        :style="{ 'marginLeft': '16px' }"
      />
      <div class="drawer-form-action">
        <a-button
          style="margin-right: 8px"
          @click="cancel"
        >
          {{ $t('shared.cancel') }}
        </a-button>
        <a-button
          type="primary"
          :disabled="checkedKeys.checked.length === 0"
          @click="filter"
        >
          {{ $t('shared.ok') }}
        </a-button>
      </div>
    </div>
  </a-drawer>
</template>

<script>
import { computed, defineComponent, ref, toRaw } from 'vue'
import { useStore } from 'vuex'

import {
  getDepartment as getDepartmentApi,
  getHrbpDepartment as getHrbpDepartmentApi,
  getHrbpDepartments as getHrbpDepartmentsApi,
  getMyDepartments as getMyDepartmentsApi
} from '@/graphql/department'

export default defineComponent({
  name: 'DepartmentStatisticFilterDrawer',
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    departmentMap: {
      type: Object,
      required: true
    }
  },
  emits: [
    'update:is-visible',
    'filter',
    'update:department-map'
  ],
  setup (props, { emit }) {
    const store = useStore()
    const expandedKeys = ref([])
    const selectedKeys = ref([])
    const treeData = ref([])
    const checkedKeys = ref({
      checked: []
    })
    const user = computed(() => store.state.user)

    const getMyDepartments = (user.value.isHrbp || user.value.isHrd)
      ? getHrbpDepartmentsApi
      : getMyDepartmentsApi
    const getDepartment = (user.value.isHrbp || user.value.isHrd)
      ? getHrbpDepartmentApi
      : getDepartmentApi

    function getChildNodes (departments) {
      const departmentNodes = departments.map(department => ({
        key: department.id,
        title: department.name,
        value: department
      }))

      return [...departmentNodes]
    }

    getMyDepartments()
      .then(rootDepartments => {
        treeData.value = [{
          key: rootDepartments[0].id,
          title: rootDepartments[0].name,
          value: rootDepartments[0]
        }]
        emit('update:department-map', {
          ...props.departmentMap,
          [rootDepartments[0].id]: rootDepartments[0].name
        })
        checkedKeys.value = {
          checked: [rootDepartments[0].id]
        }
        expandedKeys.value = [rootDepartments[0].id]
        emit('filter', [rootDepartments[0].id])
      })

    function onLoadData (departmentNode) {
      return getDepartment(departmentNode.value.id)
        .then(res => {
          const subdepartments = getChildNodes(res.childIds, res.userIds)
          emit('update:department-map', {
            ...props.departmentMap,
            ...subdepartments.reduce((map, cur) => {
              map[cur.key] = cur.title
              return map
            }, {})
          })
          departmentNode.dataRef.children = subdepartments
        })
    }

    function filter () {
      emit('filter', [...toRaw(checkedKeys.value.checked)])
      emit('update:is-visible', false)
    }

    function cancel () {
      emit('update:is-visible', false)
    }

    function uncheckKey (key) {
      checkedKeys.value.checked = checkedKeys.value.checked.filter(id => id !== key)
    }

    return {
      expandedKeys,
      selectedKeys,
      checkedKeys,
      treeData,
      onLoadData,
      filter,
      cancel,
      uncheckKey
    }
  }
})
</script>

<style lang="less" scoped>
.tree-container {
  height: calc(100vh - 48px * 2);
  overflow: auto;
}
</style>
